import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editProductItem: {
    data: {},
    isEditMode: false,
  },
};
const productItemSlice = createSlice({
  name: "productItem",
  initialState,
  reducers: {
    setIsEditMode: (state, action) => {
      state.editProductItem = action.payload;
    },
    clearEditProductItem: (state) => {
      state.editProductItem = {
        data: {},
        isEditMode: false,
      };
    },
  },
});

export const { setIsEditMode, clearEditProductItem } = productItemSlice.actions;
export default productItemSlice.reducer;
